/**
 * Confidentialité des montants — état UI en mémoire uniquement (jamais
 * persisté : masqué par défaut à chaque chargement de session). Le flag
 * consommé par `formatMoney` (lib/utils.ts) est un module-scope ; ce store
 * ne fait qu'orchestrer le re-render de l'app quand il change.
 */
import { create } from "zustand";

import { setAmountsVisible } from "@/lib/utils";

interface AmountsState {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  /** Fenêtre de déverrouillage (mot de passe) ouverte. Une seule instance,
   *  montée dans le layout : l'œil de la navbar comme l'œil devant chaque
   *  montant masqué la demandent via `requestUnlock`. */
  unlockOpen: boolean;
  requestUnlock: () => void;
  closeUnlock: () => void;
}

export const useAmountsStore = create<AmountsState>((set) => ({
  visible: false,
  setVisible: (visible) => {
    setAmountsVisible(visible);
    set({ visible });
  },
  unlockOpen: false,
  requestUnlock: () => set({ unlockOpen: true }),
  closeUnlock: () => set({ unlockOpen: false }),
}));
